import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import LoginPage from './component/login/LoginPage';
// import Home from './component/home/Home';
import FundRelease from './component/fund_request/FundRelease';
import FundAllocation from './component/fund_request/FundAllocation';
import FundRequest from './component/fund_request/FundRequest';
import FundFristLvlVerification from './component/fund_request/FundFristLvlVerification';
import FundApproval from './component/fund_request/FundApproval';
import FundSecLevelVerification from './component/fund_request/FundSecLevelVerification';
import FundRefund from './component/fund_request/FundRefund';
import FundAudit from './component/fund_request/FundAudit';
import UploadRecipetCopy from './component/fund_request/UploadRecipetCopy';

import BillAuditing from './component/billings/BillAuditing';
import BillSubmission from './component/billings/BillSubmission';
import ConsleBillGen from './component/billings/ConsleBillGen';
import FirstLevelBill from './component/billings/FirstLevelBill';
import JobAuditing from './component/billings/JobAuditing';
import SecondLvl from './component/billings/SecondLvl';
import SepratedBill from './component/billings/SperatedBillgen/SepratedBill';
import QuotationImporter from './component/Master/QuotationImporter';
import QuotationForwarder from './component/Master/QuotationForwarder';
import CustomActivity from './component/CustomActivity/CustomActivity';
import BeSbUpdation from './component/besb_updation/BeSbUpdation';
import Tracking from './component/tracking/Tracking';

import FundRefundReport from './component/Reports/FundReports/FundRefundReports'
import FundStatus from './component/Reports/FundReports/FundStatus'
import DSR1 from './component/Reports/DailyStatusReports/DSR1'
import DSR2 from './component/Reports/DailyStatusReports/DSR2'
import DSR3 from './component/Reports/DailyStatusReports/DSR3'
import BillDetailsReport from './component/Reports/BillReports/BillDetailsReport'
import BillSummaryReport from './component/Reports/BillReports/BillSummaryReport'
import GSTR1Reports from './component/Reports/BillReports/GSTR1Reports'
import ConsoleBillInvoiceReport from './component/Reports/BillReports/ConsoleBillInvoiceReport'
import CustomerWiseBillReports from './component/Reports/BillReports/CustomerWiseBillReports'
import InvoiceBillDownload from './component/Reports/BillReports/InvoiceBillDownload'
import MultipleBillDownload from './component/Reports/BillReports/MultipleBillDownload'
import QuotationDownload from './component/Reports/BillReports/QuotationDownload'
import TallyIntegrationReport from './component/Reports/BillReports/TallyIntegrationReport'
import SupplimentaryBillReport from './component/Reports/BillReports/SupplimentaryBillReport'
import BillingDepartmentEmployeeReport from './component/Reports/OperationReports/BillingDepartmentEmployeeReport'
import BillingWiseReport from './component/Reports/OperationReports/BillWiseReport'
import BranchWiseReport from './component/Reports/OperationReports/BranchWiseReport';
import CustomerWiseReport from './component/Reports/OperationReports/CustomerWiseReport';
import CheckListExcelReport from './component/Reports/OperationReports/CheckListExcelReport';
import DocumentationEmployeeReport from './component/Reports/OperationReports/DocumentationEmployeeReport';
import ExpenseReport from './component/Reports/OperationReports/ExpenseReport';
import FundRequestEmployeeReport from './component/Reports/OperationReports/FundRequestEmployeeReport';
import PaymentExpenseEmployeeReport from './component/Reports/OperationReports/PaymentExpenseEmployeeReport';
import OperationDeptWiseEmployeeReport from './component/Reports/OperationReports/OperationDeptWiseEmployeeReport';
import ProfitAndLoseReport from './component/Reports/OperationReports/ProfitAndLoseReport';
import Country from './component/masterdata/Place/Country';
import State from './component/masterdata/Place/State';
import ClearanceLoc from './component/masterdata/Place/ClearanceLoc';
import Itemtype from './component/masterdata/Billing/Itemtype';
import Chargetype from './component/masterdata/Billing/Chargetype';
import Billcharge from './component/masterdata/Billing/Billcharge';
import Unitofmeasurement from './component/masterdata/Billing/Unitofmeasurement';
import Account from './component/masterdata/Accounts/Account';
import Voucher from './component/masterdata/Accounts/Voucher';
import Payment from './component/masterdata/Accounts/Payment';
import Billpaidto from './component/masterdata/Accounts/Billpaidto';
import Billpaidby from './component/masterdata/Accounts/Billpaidby';
import Printedtype from './component/masterdata/Accounts/Printedtype';
import CheckListAprovel from './component/checklist/CheckListAprovel';
import CheckListSendParty from './component/checklist/CheckListSendParty';
import CheckListVerify from './component/checklist/CheckListVerify';
import DashBoard from './component/home/DashBoard';
import BillEdit from './component/Reports/BillReports/BillEdit';
import TransportBill from './component/transportetion_bill/TransportBill';
import BLEntry from './component/bl_entry/BLEntry';



// import IdleTimerContainer from './component/IdleTimerContainer';

function App() {
  return (
    <div >
      {/* <IdleTimerContainer> */}
      <BrowserRouter basename={'/Scope_erp'}>
      {/* <BrowserRouter basename={'/ngp_erp_v2'}> */}
        <Routes >
          <Route exact path={'/'} element={<LoginPage />} ></Route>
          <Route path={'/home'}  element={<DashBoard />} ></Route>

          <Route path='/billaudit' element={<BillAuditing />} ></Route>
          <Route path='/billSub' element={<BillSubmission />} ></Route>
          <Route path='/conslBills' element={<ConsleBillGen />} ></Route>
          <Route path='/1stlvl' element={<FirstLevelBill />} ></Route>
          <Route path='/2ndlvl' element={<SecondLvl />} ></Route>
          <Route path='/jobAudit' element={<JobAuditing />} ></Route>
          <Route path='/sepbill' element={<SepratedBill />} ></Route>
          <Route exact path={'/trans_pay'} element={<TransportBill />} ></Route>

          

          <Route path='/bl_entry' element={<BLEntry />}></Route>

          <Route path='/qutationImporter' element={<QuotationImporter />}></Route>
          <Route path='/qutationForwarder' element={<QuotationForwarder />}></Route>

          <Route path='/customactivity' element={<CustomActivity />}></Route>

          <Route path='/besbupdation' element={<BeSbUpdation />}></Route>

          <Route path='/tracking' element={<Tracking />}></Route>

          <Route exact path={'/fundreq'} element={<FundRequest />} ></Route>
          <Route exact path={'/fundaprvl'} element={<FundApproval />} ></Route>
          <Route exact path={'/fund1stlvlvrfy'} element={<FundFristLvlVerification />} ></Route>
          <Route exact path={'/fund2ndlvlvrfy'} element={<FundSecLevelVerification />} ></Route>
          <Route exact path={'/fundallocation'} element={<FundAllocation />} ></Route>
          <Route exact path={'/fundrels'} element={<FundRelease />} ></Route>
          <Route exact path={'/fundrefund'} element={<FundRefund />} ></Route>
          <Route exact path={"/fundaudit"} element={<FundAudit/>}></Route>
          <Route exact path={"/fund_rcptCpy"} element={<UploadRecipetCopy/>}></Route>

          {/* reports */}
          <Route exact path={'/FundRefundReport'} element={<FundRefundReport />} ></Route>
          <Route exact path={'/billedit'} element={<BillEdit />} ></Route>
          <Route exact path={'/FundStatus'} element={<FundStatus />} ></Route>
          <Route exact path={'/DSR1'} element={<DSR1 />} ></Route>
          <Route exact path={'/DSR2'} element={<DSR2 />} ></Route>
          <Route exact path={'/DSR3'} element={<DSR3 />} ></Route>
          <Route exact path={'/BillDetailsReport'} element={<BillDetailsReport />} ></Route>
          <Route exact path={'/BillSummaryReport'} element={<BillSummaryReport />} ></Route>
          <Route exact path={'/GSTR1Reports'} element={<GSTR1Reports />} ></Route>
          <Route exact path={'/ConsoleBillInvoiceReport'} element={<ConsoleBillInvoiceReport />} ></Route>
          <Route exact path={'/CustomerWiseBillReports'} element={<CustomerWiseBillReports />} ></Route>
          <Route exact path={'/InvoiceBillDownload'} element={<InvoiceBillDownload />} ></Route>
          <Route exact path={'/MultipleBillDownload'} element={<MultipleBillDownload />} ></Route>
          <Route exact path={'/QuotationDownload'} element={<QuotationDownload />} ></Route>
          <Route exact path={'/TallyIntegrationReport'} element={<TallyIntegrationReport />} ></Route>
          <Route exact path={'/SupplimentaryBillReport'} element={<SupplimentaryBillReport />} ></Route>
          <Route exact path={'/BillingDepartmentEmployeeReport'} element={<BillingDepartmentEmployeeReport />} ></Route>
          <Route exact path={'/BillingWiseReport'} element={<BillingWiseReport />} ></Route>
          <Route exact path={'/BranchWiseReport'} element={<BranchWiseReport />} ></Route>
          <Route exact path={'/CustomerWiseReport'} element={<CustomerWiseReport />} ></Route>
          <Route exact path={'/ExpenseReport'} element={<ExpenseReport />} ></Route>
          <Route exact path={'/ChecklistExcelReport'} element={<CheckListExcelReport />} ></Route>
          <Route exact path={'/DocumentationEmployeeReport'} element={<DocumentationEmployeeReport />} ></Route>
          <Route exact path={'/FundRequestEmployeeReport'} element={<FundRequestEmployeeReport />} ></Route>
          <Route exact path={'/ProfitAndLoseReport'} element={<ProfitAndLoseReport />} ></Route>
          <Route exact path={'/PaymentExpenseEmployeeReport'} element={<PaymentExpenseEmployeeReport />} ></Route>
          <Route exact path={'/OperationDeptWiseEmployeeReport'} element={<OperationDeptWiseEmployeeReport />} ></Route>
          <Route exact path={'/Country'} element={<Country />} ></Route>
          <Route exact path={'/State'} element={<State />} ></Route>
          <Route exact path={'/ClearanceLoc'} element={<ClearanceLoc />} ></Route>
          <Route exact path={'/Itemtype'} element={<Itemtype />} ></Route>
          <Route exact path={'/Chargetype'} element={<Chargetype />} ></Route>
          <Route exact path={'/Billcharge'} element={<Billcharge />} ></Route>
          <Route exact path={'/Unitofmeasurement'} element={<Unitofmeasurement />} ></Route>
          <Route exact path={'/Account'} element={<Account />} ></Route>
          <Route exact path={'/Voucher'} element={<Voucher />} ></Route>
          <Route exact path={'/Billpaidto'} element={<Billpaidto />} ></Route>
          <Route exact path={'/Billpaidby'} element={<Billpaidby />} ></Route>
          <Route exact path={'/Payment'} element={<Payment />} ></Route>
          <Route exact path={'/Printedtype'} element={<Printedtype />} ></Route>

          <Route exact path={'/checklistApprovalbMngr'} element={<CheckListAprovel />} ></Route>
          <Route exact path={'/checklistSndParty'} element={<CheckListSendParty />} ></Route>
          <Route exact path={'/checklistVerify'} element={<CheckListVerify />} ></Route>

        </Routes>
      </BrowserRouter>
      {/* </IdleTimerContainer> */}
    </div>
  );
}

export default App;
